/**
 * @description 對應車險保險類型用
*/
export enum VehiclePolicyType {
    /** 強制險 */
    Compulsory = '1',
    /** 任意險 */
    Arbitrary = '2'
}
